import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalBody } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

export default function VoucherWarningModal({
  children,
}) {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <React.Fragment>
      <button className="btn btn-primary btn-block" onClick={() => { setModalOpen(true); }}>
        <FormattedMessage id="key-reveal-warning-button.btn.main" defaultMessage="Reveal coupon" />
      </button>
      <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)} className="account-modal">
        <ModalBody>
          <div className="account-modal-title">
            <FormattedMessage id="key-reveal-warning.modal.title" defaultMessage="Please note" />
          </div>

          <div className="account-modal-form">
            <p className="account-modal-paragraph">
              <FormattedMessage id="key-reveal-warning.modal.paragraph.one" defaultMessage="Once you have used this coupon to place another order, you will no longer be eligible for a full refund on this order. The value of the coupon would be deducted from your refund total." />
            </p>
            <p className="account-modal-paragraph">
              <FormattedMessage id="key-reveal-warning.modal.paragraph.two" defaultMessage="If you wish to continue and use your coupon, please confirm you accept this." />
            </p>

            <div className="account-modal-form-buttons">
              <div className="form-button-container full-width">
                {children}
              </div>
              <div className="form-button-container full-width">
                <Button color="secondary" onClick={() => { setModalOpen(false); }}>
                  <FormattedMessage id="key-reveal-warning.btn.cancel" defaultMessage="Cancel" />
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>

        <div className="close-button-container">
          <button aria-label="close" onClick={() => { setModalOpen(false); }}>
            <FontAwesomeIcon icon={faXmark} title="Close modal" />
          </button>
        </div>
      </Modal>
    </React.Fragment>
  );
}

VoucherWarningModal.propTypes = {
  children: PropTypes.node.isRequired,
};
